// extracted by mini-css-extract-plugin
export default {"tile":"InfluencerTile_tile__VTgyU","logo":"InfluencerTile_logo__yDdDP"};